export default __webpack_public_path__ + "static/media/logo.fdc3810e684384a522b6e9b9bc7bdde6.png";